
import DeckGL from 'deck.gl'
import { Deck, MapViewState } from '@deck.gl/core';
import { ScatterplotLayer, GeoJsonLayer } from '@deck.gl/layers';
import type { GeoJsonLayerProps } from '@deck.gl/layers';
import { Box, Card, Collapse, Grid, Grid2, Tab, Table, TableCell, tableCellClasses, TableRow, Tabs, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import type { Feature, Geometry } from 'geojson';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { Navigate, useNavigate } from 'react-router-dom';
import { last5columns, organisationColumns } from '../../components/common/tables/Columns';
import fontConfigs from '../../configs/fontConfigs';
import colorConfigs from '../../configs/colorConfigs';
import { LatestDCMSessionStorageKey, LatestDCMTableParameterStorageService } from "../../services/sessionStorage";
import * as Yup from "yup";
import { Field, FormikProvider, useFormik } from 'formik';
import dayjs from 'dayjs';
import api from "../../redux/features/auth/axiosAuthHelper";
import { refreshAccessToken } from '../../redux/features/auth/authSlice';
import ResultDetailGraph from '../../components/common/graphs/ResultDetailGraph';
import LastFiveResultsTable from "../../components/common/tables/LastFiveResultsTable";
import { ResultDetailTableDashboardField } from '../../components/common/fields/fields';
import TestsGraph from "../../components/common/graphs/TestInsightsGraph";
import ResultSourceRadialGraph from '../../components/common/graphs/ResultSourceRadialGraph';
import RareChip from "../../components/common/buttons/RareChip";
import assets from '../../assets';
import RecentResultsTable from '../../components/common/tables/RecentResultsTable';
import LastFiveNeedsReviewedTable from '../../components/common/tables/LastFiveNeedsReviewedTable';
import LastFiveAbortedResultsTable from '../../components/common/tables/LastFiveAbortedResultsTable';
import MapContainer from '../../components/common/cards/MapContainer';
import DashboardMap from '../../components/common/cards/DashboardMap';

// const COUNTRIES =
//   'https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_50m_admin_0_scale_rank.geojson';

// const INITIAL_VIEW_STATE: MapViewState = {
//   latitude: 37.8,
//   longitude: -122.45,
//   zoom: 15
// };

// type DataType = {
//   position: [longitude: number, latitude: number];
//   color: [r: number, g: number, b: number];
//   radius: number;
// };

// type PropertiesType = {
//   name: string;
//   color: string;
// };

const HomePage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>();

  const [sourceValue, setSourceValue] = useState('radar')
  const [recentReviewRows, setRecentReviewRows] = useState<any[]>([]);
  const [latestResults, setLatestResults] = useState<any>([]);
  const [totalResultCount, setTotalResultCount] = useState<any>(null);
  const [totalUserCount, setTotalUserCount] = useState<any>(null);
  const [totalOrgCount, setTotalOrgCount] = useState<any>(null);
  const [totalNeedsReviewedCount, setTotalNeedsReviewedCount] = useState<any>(null);
  const [recentlyViewedResults, setRecentlyViewedResults] = useState<any>([]);

  const [recentlyAbortedResults, setRecentlyAbortedResults] = useState<any>([]);
  const [totalAbortedResults, setTotalAbortedResults] = useState<any>(0);
  const [topAbortedResults, setTopAbortedResults] = useState<any>([]);
  const [abortRate, setAbortRate] = useState<any>(null);


  const [graphData, setGraphData] = useState<any>({
    test_lines: [],
    cscore: '',
    cpeak: '',
    profile: [''],
    baseline: [''],
    c_color: '',
    baseline_color: '',
    profile_color: '',
    profiles: [],
    baselines: [],
    meanProfileVisible: false,
  })

  const authData = useSelector((state: RootState) => state.auth);

  const validationSchema = () => {
    return Yup.object().shape({
    });
  }
  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      app_build: '',
      app_version: '',
      device_model: '',
      device_uuid: '',
      full_image: '',
      id: '',
      latitude: '',
      longitude: '',
      notes: '',
      organisation_id: '',
      os_version: '',
      sample_id: '',
      sample_type: '',

      strip_image_paths: [],
      // Test lines
      baseline: '',
      cline_score: '',
      cline_peak_position: '',
      cline_peak_area: '',
      // Lines
      t_lines: [],
      tline_1_score: '',
      tline_1_area: '',
      tline_1_peak_position: '',
      tline_1_ratio: '',
      tline_2_score: '',
      tline_2_area: '',
      tline_2_peak_position: '',
      tline_2_ratio: '',
      profile: '',

      timestamp: '',
      user_id: '',
      uuid: '',
      tc_area_ratio: '',

      // User Data
      result_user_id: '',
      user_first_name: '',
      user_last_name: '',
      user_email: '',
      user_is_active: '',
      user_organisation_id: '',
      user_organisation_name: '',
      user_user_type: '',
      user_subscription_tier: '',

      camera_macro_focus_required: false,
      collection_mode: false,
      control_baseline: false,
      control_baseline_threshold: '',
      control_exposure: false,
      control_line_correction: false,
      flash_required: false,
      frames_to_capture: '',
      initial_h_factor: '',
      polynomial_baseline_order: '',
      profile_alignment: false,
      profile_control_levels: '',
      reader_resolution: [],
      test_pmf_classifier_file: '',
      max_conformance_probability: '',
      min_conformance_probability: '',
    },
    validationSchema,
    onSubmit: (values) => {
    },
  });

  // This use effect fetches the latest result, total count of results and the latest results user
  const fetchResult = async () => {
    try {
      const url = `results/?limit=10`

      const response = await api.get(url, {
        headers: {
          'Authorization': `Bearer ${authData.access}`
        }
      });
      setTotalResultCount(response.data.count);
      setLatestResults(response.data.results)
      console.log("results", response.data)

    } catch (error) {
      console.error('Error fetching result', error);
      // setErrors(`No Result found with ID ${result_id}`)
    }
  };

  const fetchRecentlyViewedResults = async () => {
    try {
      // Get today's date and subtract 30 days
      const today = new Date();
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(today.getDate() - 30);
      // Format to YYYY-MM-DD
      const latest_access_from_date = thirtyDaysAgo.toISOString().split('T')[0];

      // Build URL with dynamic date
      const url = `results/?latest_access_from_date=${latest_access_from_date}&limit=10`;

      const response = await api.get(url, {
        headers: {
          'Authorization': `Bearer ${authData.access}`
        }
      });
      setRecentlyViewedResults(response.data.results);
      console.log("results", response.data);
    } catch (error) {
      console.error('Error fetching result', error);
    }
  };


  const fetchUsers = async () => {
    try {
      const url = `users/`
      const response = await api.get(url, {
        headers: {
          'Authorization': `Bearer ${authData.access}`
        }
      });
      setTotalUserCount(response.data.count);
    } catch (error) {
      console.error('Error fetching users', error);

    }
  }

  const fetchOrganisations = async () => {
    try {
      const url = `organisations/`
      const response = await api.get(url, {
        headers: {
          'Authorization': `Bearer ${authData.access}`
        }
      });
      setTotalOrgCount(response.data.count ? response.data.count : 0);
    } catch (error) {
      console.error('Error fetching organisations', error);

    }
  }

  const fetchNeedsReviewed = async () => {
    try {
      const url = `results/?visual_result_is_reviewed=false&limit=10`
      const response = await api.get(url, {
        headers: {
          'Authorization': `Bearer ${authData.access}`
        }
      });
      setTotalNeedsReviewedCount(response.data.count ? response.data.count : 0);
      setRecentReviewRows(response.data.results)
    } catch (error) {
      console.error('Error fetching organisations', error);

    }
  }

  const fetchcAbortedResults = async () => {
    try {
      const url = `results/aborted-result-stats`
      const response = await api.get(url, {
        headers: {
          'Authorization': `Bearer ${authData.access}`
        }
      });
      setRecentlyAbortedResults(response.data.recent_aborted_scans);
      setTotalAbortedResults(response.data.total_aborted_scans);
      setTopAbortedResults(response.data.top_abort_reasons);
      setAbortRate(response.data.abort_rate);
    } catch (error) {
      console.error('Error fetching organisations', error);

    }
  }

  useEffect(() => {
    fetchNeedsReviewed()
    fetchOrganisations()
    fetchUsers()
    fetchResult()
    fetchRecentlyViewedResults()
    fetchcAbortedResults()
  }, [authData])


  const handleSourceTabsChange = (event: React.SyntheticEvent, newValue: string) => {
    setSourceValue(newValue);
    console.log(sourceValue)
  };

  const graphDataLength = graphData.test_lines.length ? graphData.test_lines.length : 1

  return (
    <div data-testid="div-ci9o">
      <Box data-testid="Box-5moc" sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 3 }}>
        <Grid2 container spacing={1} sx={{ pr: 1 }}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <Card data-testid="Card-j4ln" sx={{ width: '100%', height: 530 }}>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ width: '100%', height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottomRightRadius: 3 }}>
                  <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>Latest Results</Typography>
                </Box>
              </Box>
              <Box sx={{ height: '100%', overflowY: 'auto' }}>
                <RecentResultsTable
                  authData={authData}
                  rows={latestResults} />
              </Box>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 8 }} alignItems='center'>
            <Card data-testid="Card-hkp5" sx={{ height: 530, width: '100%', alignItems: 'center', justifyContent: "center" }} >
              {/* <Typography sx={{ fontSize: fontConfigs.detailPage.headings.title, textAlign: 'center', minWidth: '100%', fontWeight: 1000, color: colorConfigs.dashboard.dark_red, p: 1, paddingX: 1.5, margin: 'auto', borderRadius: 1 }}>
                Results Map
              </Typography> */}
              {/* <DashboardMap /> */}
              <MapContainer />

            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 3 }}>
            <Card data-testid="Card-dv4c" sx={{ height: 270, alignItems: 'center', justifyContent: "center" }}>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ width: '100%', height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottomRightRadius: 3 }}>
                  <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>Recently viewed</Typography>
                </Box>
              </Box>
              <Box sx={{ height: '100%', overflowY: 'auto' }}>
                <LastFiveResultsTable
                  authData={authData}
                  rows={recentlyViewedResults} />
              </Box>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 3 }} alignItems='center'>
            <Card data-testid="Card-j4r0" sx={{ height: 270, alignItems: 'center', justifyContent: "center" }}>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ width: '100%', height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottomRightRadius: 3 }}>
                  <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>{`${totalNeedsReviewedCount} Require Review`}</Typography>
                </Box>
              </Box>
              <Box sx={{ height: '100%', overflowY: 'auto' }}>
                <LastFiveNeedsReviewedTable
                  authData={authData}
                  rows={recentReviewRows} />
              </Box>
            </Card>
          </Grid2>
          {(authData?.user?.user_type === "DDTD_ADMIN" || authData.isOrganisationAdmin) &&
            <Grid2 size={{ xs: 12, sm: 3 }} alignItems='center'>
              <Card data-testid="Card-hw4k" sx={{ height: 270, alignItems: 'center', justifyContent: "center" }}>
                <Box sx={{ display: 'flex' }}>
                  <Box sx={{ width: '100%', height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottomRightRadius: 3 }}>
                    <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>Aborted Results</Typography>
                  </Box>
                </Box>
                <Box sx={{ height: '100%', overflowY: 'auto' }}>
                  <LastFiveAbortedResultsTable
                    authData={authData}
                    rows={recentlyAbortedResults} />
                </Box>
              </Card>
            </Grid2>
          }
          <Grid2 size={{ xs: 12, sm: 3 }} alignItems='center'>
            <Card data-testid="Card-hw4k" sx={{ height: 270, alignItems: 'center', justifyContent: "center" }}>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ width: '100%', height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottomRightRadius: 3 }}>
                  <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>{authData.isSuperUser || authData.isDDTDAdmin || authData.isDDTDUser ? "Organisations" : "Organisation"}</Typography>
                </Box>
              </Box>
              <Table data-testid="Table-3sci" sx={{ width: '100%', height: 'auto', [`& .${tableCellClasses.root}`]: { borderBottom: "none" }, borderCollapse: 'separate', borderSpacing: '0 0px' }}>

                <TableRow>
                  <TableCell sx={{ py: 1 }}>
                    <Typography sx={{ ...fontConfigs.detailPage.headings.label, color: colorConfigs.dashboard.dark_grey }}>
                      Users
                    </Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ py: 1 }}>
                    <RareChip variant="success">{(totalUserCount ? totalUserCount : "loading...")}</RareChip>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ py: 1 }}>
                    <Typography sx={{ ...fontConfigs.detailPage.headings.label, color: colorConfigs.dashboard.dark_grey }}>
                      Results
                    </Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ py: 1 }}>
                    <RareChip variant="success">{(totalResultCount ? totalResultCount : "loading...")}</RareChip>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ py: 1 }}>
                    <Typography sx={{ ...fontConfigs.detailPage.headings.label, color: colorConfigs.dashboard.dark_grey }}>
                      {authData.isSuperUser || authData.isDDTDAdmin || authData.isDDTDUser ? "Organisations" : "Test Type"}
                    </Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ py: 1 }}>
                    <RareChip variant="success">{authData.isSuperUser || authData.isDDTDAdmin || authData.isDDTDUser ? (totalOrgCount ? totalOrgCount : "loading...") : "Oncho"}</RareChip>
                  </TableCell>
                </TableRow>
              </Table>

            </Card>
          </Grid2>
        </Grid2>
      </Box>
    </div>
  )
};


export default HomePage;